<div class="d-flex justify-content-center mt-5" style="height: 100vh">
    <app-loader></app-loader>
</div>